import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { Colors, Typographies } from 'src/components/theme'

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow={props.arrow !== undefined ? props.arrow : true} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    '&:before': {
      boxShadow: `1px 1px 1px 0px rgb(0 0 0 / 10%), 0px 1px 1px 0px rgb(0 0 0 / 5%)`,
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: Colors.bgWhite,
    color: Colors.textBlack,
    fontSize: Typographies.text1.fontSize,
    boxShadow: Colors.BOX_SHADOW,
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    marginBottom: '5px !important',
  },
}))
